import { react, useEffect, useState, useRef } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TokenService from '../../services/TokenService'
import Image from 'mui-image';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
//   import Cookies from 'universal-cookie';
import { useSnackbar } from 'notistack';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import StyledCheckbox from './../StyledExtensions/StyledCheckbox';
import StyledRadio from './../StyledExtensions/StyledRadio';
import dayjs from 'dayjs';
import UpdateIcon from '@mui/icons-material/Update';
import AddIcon from '@mui/icons-material/Add';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Fab from '@mui/material/Fab';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import ChatBox from '../Chat/ChatBox.jsx';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import Avatar from '@mui/material/Avatar';
import EditIcon from '@mui/icons-material/Edit';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import cloneDeep from 'lodash/cloneDeep';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import BusinessHours from './BusinessHours.jsx';
import PaymentOptions from './PaymentOptions.jsx';
import TipPrompt from './TipPrompt.jsx';
import EstimateSummary from './EstimateSummary.jsx';
import StoreSelection from './StoreSelection.jsx';
import EstimateItem from './EstimateItem.jsx';
import * as RetailStores from './RetailStores.js';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../Modals/ConfirmDialog';
import ReassignPickupModal from '../Modals/ReassignPickupModal';


export default function AdminOrderView(props) {
    var utc = require('dayjs/plugin/utc')
    dayjs.extend(utc)

    const [order, setOrder] = useState(props.order);
    const [loggedInUser, setLoggedInUser] = useState(props.loggedInUser);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [availableDate, setAvailableDate] = useState(props.order == null || props.order.CustomerDateAvailableForPickup === undefined ? dayjs() : props.order.CustomerDateAvailableForPickup.Data);
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [showDialog, setShowDialog] = useState('');
    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });
    const [unscheduleReason, setUnscheduleReason] = useState('');
    const [unscheduleReasonOther, setUnscheduleReasonOther] = useState('');

    const [customerFirstname, setCustomerFirstname] = useState('');
    const [customerLastname, setCustomerLastname] = useState('');
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState('');
    const [hasMobileUpdates, setHasMobileUpdates] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(null);
    const [notifyCustomerOnUpdate, setNotifyCustomerOnUpdate] = useState(false);
    const [notifyRecyclerOnUpdate, setNotifyRecyclerOnUpdate] = useState(false);
   
    const prevCustomerPhoneNumber = useRef();
    useEffect(() => {
        //assign the ref's current value to the count Hook
        prevCustomerPhoneNumber.current = customerPhoneNumber;
    }, [customerPhoneNumber]); //run this code when the value of customerPhoneNumber changes
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerAddressStreet, setCustomerAddressStreet] = useState('');
    const [customerAddressStreet2, setCustomerAddressStreet2] = useState('');
    const [customerAddressCity, setCustomerAddressCity] = useState('');
    const [customerAddressState, setCustomerAddressState] = useState('');
    const [customerAddressZip, setCustomerAddressZip] = useState('');
    const [quantity, setQuantity] = useState('');
    const [customerCheckPayeeName, setCustomerCheckPayeeName] = useState('');
    const [customerPaymentMethod, setCustomerPaymentMethod] = useState('');
    const [showTipAmountPrompt, setShowTipAmountPrompt] = useState(false);
    const [tipAmount, setTipAmount] = useState('');
    const [specialInstructions, setSpecialInstructions] = useState('');
    const [customerPhotoDataBase64String, setCustomerPhotoDataBase64String] = useState('');
    const [customerPhotoDataBase64String2, setCustomerPhotoDataBase64String2] = useState('');
    const [customerPhotoDataBase64String3, setCustomerPhotoDataBase64String3] = useState('');
    const [customerPhotoDataBase64String4, setCustomerPhotoDataBase64String4] = useState('');
    const [customerPhotoDataBase64String5, setCustomerPhotoDataBase64String5] = useState('');
    const adminSendPaypalTransactionId = useRef();

      useEffect(() => {
        // first load processing
          setOrderData(props.order);
      }, []) // <-- empty dependency array to prevent this from running every update

   // useEffect(() => {
   //     // first load processing
   //     console.log("Order: First load");
   //     let queryParams = new URLSearchParams(window.location.search);
   //     let orderParm = queryParams.get("Order");
   //     setOrderId(orderParm);
        

   //     if (orderParm != null) {
   //         setIsFetching(true);

   ////         const cookies = new Cookies();
   //         let loginToken = getWebToken();
   //         let postData = {
   //             OrderGUID: orderParm,
   //             token: loginToken == undefined ? '' : loginToken
   //         }

   //         //
   //         TokenService.post(postData, 'GetOrderDetailsByGuid', '')
   //             .then((response) => {
   //                 if (response !== null) {
   //                     setIsFetching(false);
   //                     response = response[Object.keys(response)[0]];
   //                     if (response.Result === "SUCCESS") {
   //                         let requestData = JSON.parse(response.JsonData);
   //                         let pickupRequest = JSON.parse(requestData.PickupRequest);
   //                         setOrderData(pickupRequest);

   //                         if (requestData.LoggedInUser != undefined) {
   //                             let user = JSON.parse(requestData.LoggedInUser);
   //                             if (typeof user === 'string') {
   //                                 user = JSON.parse(user);
   //                             }
   //                             setLoggedInUser(user);
   //                         }

   //                     }
   //                     else if (response.Result === "FAIL") {
                            
   //                         enqueueSnackbar(response.Message, {
   //                             variant: 'error',
   //                         });
   //                     }
   //                 }
   //             })
   //             .catch((response) => {
   //                 setIsFetching(false);
   //                 if (response !== null) {
   //                     if (response.Result === "FAIL") {
   //                         enqueueSnackbar('Oops, something went wrong', {
   //                             variant: 'error',
   //                         });
   //                     }

   //                 }
   //             });

   //     }
        


   // }, []) // <-- empty dependency array to prevent this from running every update

    function openDialog(dialog) {
        setFormValidation({
            errors: [],
            isValid: true
        });
        
        setOrderData(order); // reinitialize any local state variables in case the customer Cancelled a previous dialog
        setShowDialog(dialog);
    }

    function setOrderData(order) {
        setOrder(order);
        setCustomerFirstname(order.CustomerName);
        setCustomerLastname(order.CustomerLastname);
        setCustomerPhoneNumber(order.CustomerPhoneNum);
        setHasMobileUpdates(order.CustomerWantsTextMsg.toUpperCase() === 'TRUE');
        setCustomerEmail(order.CustomerEmail);
        setCustomerAddressStreet(order.CustomerAddress_Street);
        setCustomerAddressStreet2(order.CustomerAddress_Apt_Suit_Other);
        setCustomerAddressCity(order.CustomerAddress_City);
        setCustomerAddressState(order.CustomerAddress_State);
        setCustomerAddressZip(order.CustomerAddress_Zipcode);
        setQuantity(order.Quantity_Of_Cans_Bottles);
        setCustomerCheckPayeeName(order.CustomerCheckPayeeName);
        setCustomerPaymentMethod(order.CustomerPaymentMethod);
        setTipAmount(order.TipAmount);
        setSpecialInstructions(order.CustomerSpecialInstructions);
        setCustomerPhotoDataBase64String(order.CustomerPhotoDataBase64String);
        setCustomerPhotoDataBase64String2(order.CustomerPhotoDataBase64String2);
        setCustomerPhotoDataBase64String3(order.CustomerPhotoDataBase64String3);
        setCustomerPhotoDataBase64String4(order.CustomerPhotoDataBase64String4);
        setCustomerPhotoDataBase64String5(order.CustomerPhotoDataBase64String5);
        setNotifyCustomerOnUpdate(false);
        setNotifyRecyclerOnUpdate(false);
    }

    let loadingPanel = null;
    let customerOrderPanel = null;


    if (isUpdating) {
        loadingPanel = <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="50px"
        >
            <CircularProgress color="secondary" />
        </Box>
    }
    else if (isFetching) {
        loadingPanel = <Grid container rowSpacing={.5} columnSpacing={1} style={{ width: '500px', maxWidth: '90%' }}>
            {/* For variant="text", adjust the height via font-size */}
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>

            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6} style={{ height: '75px' }} >
                <Skeleton variant="text" style={{ marginTop: '20px' }} height={40} sx={{ fontSize: '1rem', alignSelf: 'center' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="circular" width={75} height={75} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>

            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>

            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem', alignSelf: 'center' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="rectangular" width={30} height={30} style={{ marginTop: '5px' }} sx={{ fontSize: '1rem' }} />
            </Grid>

            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>


            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
            <Grid item xs={6}>
                <Skeleton variant="text" height={40} sx={{ fontSize: '1rem' }} />
            </Grid>
        </Grid>
    }
    else if (Object.keys(order).length != 0) {
        let payToTheOrderOf = null;
     
        customerOrderPanel = buildOrder();
    }


    function handleMoveBackToMarketplaceClicked() {
        setConfirmDialog({
            show: true,
            close: closeMoveBackToMarketplaceDialog,
            title: 'Move back to Marketplace?',
            cancelText: 'Cancel',
            acceptText: 'Proceed',
            content: <div>
                <div>This will silently Unschedule this request and re-send all returner notifications.</div>
            </div>,
            data: ''
        });
    }

    function handleCloseAndPayClicked() {
        //adminSendPaypalTransactionId.current.value = '';
        setConfirmDialog({
            show: true,
            close: closeAndPayClosed,
            title: 'Close & Pay request?',
            cancelText: 'Cancel',
            acceptText: 'Proceed',
            content: <div>
                <div>This will close the order, leaving it assigned to the current recycler. It will issue the payment to the customer as if it was just paid.</div>
                <div>
                    <div style={{marginTop:'25px'} }>
                        Enter the Paypal Transaction Id from the Recycler's payment
                    </div>
                    <TextField placeholder={'Paypal Transaction Id'} inputRef={adminSendPaypalTransactionId} />
                </div>
            </div>,
            data: ''
        });
    }

    function handleAssignToMe() {
        setConfirmDialog({
            show: true,
            close: closeAssignToSelfDialog,
            title: 'Assign this order to yourself?',
            cancelText: 'Cancel',
            acceptText: 'Proceed',
            content: <div>
                <div>Do you want to assign this order to yourself?</div>
                <Scheduler PickupRequest={order} onScheduled={props.onScheduled} viewType='Admin' />
            </div>,
            data: ''
        });
    }

    function closeAssignToSelfDialog(didAccept) {
        if (didAccept) {
            TokenService.adminServicePost({ orderGUID: props.order.OrderGUID, assignToEmail:'' }, 'Admin_ReassignOrder')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        enqueueSnackbar('Order Reassigned to you.', {
                            variant: 'success',
                        });
                    }
                    let jsonData = JSON.parse(response.JsonData);
                    let updOrder = JSON.parse(jsonData.Order);
                    if (typeof updOrder === 'string') {
                        updOrder = JSON.parse(updOrder);
                    }
                    setOrder(updOrder);
                    if (props.orderUpdated !== undefined) {
                        props.orderUpdated(updOrder)
                    }
                    
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
            
        }
        setConfirmDialog(null);
        
    }

    function closeAssignToOtherDialog(didAccept, recycler, selectedDate, selectedTime) {
        if (didAccept) {
            if (recycler == null || recycler == undefined) {
                enqueueSnackbar('You must select a recycler to re-assign this order', {
                    variant: 'error',
                });
            }
            else {
                let postData = {
                    orderGUID: props.order.OrderGUID,
                    assignToEmail: recycler.EmailAddress,
                    selectedDate: selectedDate,
                    selectedTime: selectedTime
                }
                TokenService.adminServicePost(postData, 'Admin_ReassignOrder')
                    .then((response) => {
                        response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {
                            let jsonData = JSON.parse(response.JsonData);
                            let updOrder = JSON.parse(jsonData.Order);
                            if (typeof updOrder === 'string') {
                                updOrder = JSON.parse(updOrder);
                            }
                            setOrder(updOrder);
                            if (props.orderUpdated !== undefined) {
                                props.orderUpdated(updOrder)
                            }
                            enqueueSnackbar('Order Reassigned to ' + updOrder.Owner + '.', {
                                variant: 'success',
                            });
                        }
                      
                    })
                    .catch((response) => {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    });
                setShowDialog(null);
            }
        }
        else {
            setShowDialog(null);
        }
    }

    function handleAssignToOther() {
        setShowDialog('Recycler Search');
    }

    function closeAndPayClosed(didAccept) {
        if (didAccept) {

            var postData = {
                orderGuid: props.order.OrderGUID,
                paypalTransactionId: adminSendPaypalTransactionId.current.value
            }
            TokenService.post(postData, 'Admin_SendPayment')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        enqueueSnackbar('This order has been closed.', {
                            variant: 'success',
                        });
                    }
                    let jsonData = JSON.parse(response.JsonData);
                    let updOrder = JSON.parse(jsonData);
                    if (typeof updOrder === 'string') {
                        updOrder = JSON.parse(updOrder);
                    }
                    setOrder(updOrder);
                    if (props.orderUpdated !== undefined) {
                        props.orderUpdated(updOrder)
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });

        }
        setConfirmDialog(null);
    }

    function closeMoveBackToMarketplaceDialog(didAccept) {

        if (didAccept) {


            TokenService.adminServicePost({ orderGUID: props.order.OrderGUID }, 'Admin_MoveBackToMarketplace')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        enqueueSnackbar('This order has been moved back to the marketplace', {
                            variant: 'success',
                        });
                    }
                    let jsonData = JSON.parse(response.JsonData);
                    let updOrder = JSON.parse(jsonData.Order);
                    if (typeof updOrder === 'string') {
                        updOrder = JSON.parse(updOrder);
                    }
                    setOrder(updOrder);
                    if (props.orderUpdated !== undefined) {
                        props.orderUpdated(updOrder)
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });

        }
        setConfirmDialog(null);

    }
   

    function buildOrder() {

        if (order === null) {
            return null;
        }

        let availDate = (dayjs(order.CustomerDateAvailableForPickup.Data));
        let selectedStores = RetailStores.getStoreIcons(order);
        let containerDetails = order.Returnable_Type_Container_Detail_JSON;
        if (typeof containerDetails === 'string' && containerDetails !== '') {
            containerDetails = JSON.parse(containerDetails);
        }

        let expirationSection = null;
        if (order.Status === 'Open' && order.Status_Reason === 'Unscheduled') {
            let expirationDate = dayjs(order.ExpirationDateTimeUTC.Data)
            expirationSection = <>
                <tr>
                    <td style={{ alignSelf: 'center', color: (expirationDate.diff(dayjs(), 'second')) < 0 ? 'red' : '', verticalAlign:'top' }}>
                        {expirationDate.diff(dayjs(), 'second') < 0 ? 'Expired on:' : 'Expiration:'}
                    </td>
                <td style={{ color: (expirationDate.diff(dayjs(), 'second')) < 0 ? 'red' : '' }}>
                    {expirationDate.format('ddd MMM D YYYY, h:mm a')}

                    {
                        expirationDate.diff(dayjs(), 'hours') <= 48 && expirationDate.diff(dayjs(), 'days') > -30 ?
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Fab size="small" sx={{ fontSize: 40, marginTop: '15px', alignSelf: 'flex-start', marginLeft: '45px', backgroundColor: 'var(--sipzee-gray-2)' }}
                                        onClick={() => openDialog('Extend Time')}
                                    aria-label="extend">
                                        <UpdateIcon sx={{ fontSize: 40, color: 'var(--sipzee-yellow)' }} />
                                </Fab>
                                Extend Expiration
                            </div>
                            : null
                    }
                    </td>
                </tr>
            </>
        }

        return (
            <>
                

                <table className='SummaryTable'>
                    <tbody>
                       
                        <tr>

                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <MonitorHeartIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} style={{ alignSelf: 'center' }} />
                                    <span style={{ alignSelf: 'center' }}>Order Status</span>
                                    {order.Status === 'Open' ?
                                        <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Order Status')} >
                                            <EditIcon sx={{ color: 'var(--sipzee-yellow)' }} />
                                        </Fab>
                                        :
                                        <span></span>
                                    }
                                </div>

                            </td>
                        </tr>
                       
                        <tr>
                            <td>Confirmation Num:</td>
                            <td> {order.RequestID}</td>
                        </tr>
                        <tr>
                            <td>Date Available:</td>
                            <td>{availDate.format('ddd MMM DD')}</td>
                        </tr>
                        {expirationSection}

                        <tr>
                            <td>
                                Status:
                            </td>
                            <td>
                                {order.Status}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Status Reason:
                            </td>
                            <td>
                                {order.Status_Reason}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Recycler Name:
                            </td>
                            <td>
                                {order.Owner_FirstName}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Recycler Photo:
                            </td>
                            <td>
                                <Avatar src={order.Status_Reason == 'Unscheduled' ? '/images/ProfileImage.png' :
                                    (order.Owner_ImagePath.indexOf('sipzeephotos.blob.core') > -1 ? order.Owner_ImagePath : 'https://sipzee.com/Returner/ReturnerProfilePics/' + order.Owner_ImagePath)
                                } sx={{ width: 75, height: 75 }} />
                              
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Scheduled Pick Up:
                            </td>
                            <td>
                                {order.Status_Reason === 'Scheduled' ?
                                    <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }} >{order.ScheduledPickUpDate} between {order.EstPickUpWindow.replace("_", "-")}
                                        </div>
                                    :
                                    order.ScheduledPickUpDate}
                            </td>
                        </tr>
                     
                        {order.Status === 'Open' ?
                            <tr>
                                <td colSpan={2} style={{ textAlign: 'center' }}>
                                    {order.Status_Reason === 'Scheduled' ?
                                          <Button variant='outlined' style={{}} sx={{ backgroundColor: 'var(--sipzee-red-2)', marginTop: '10px' }} onClick={() => handleMoveBackToMarketplaceClicked()}>Back to Market</Button>
                                        : null
                                    }

                                    {order.Status_Reason === 'Scheduled' || order.Status_Reason === 'Unscheduled' ?
                                        <Button variant='outlined' style={{}} sx={{ backgroundColor: 'var(--sipzee-red-2)', marginTop: '10px', marginLeft: '5px', marginRight: '5px' }} onClick={() => handleAssignToOther()}>Assign to...</Button>
                                        : null
                                    }
                                    {order.Status_Reason === 'Scheduled' ?
                                        <Button variant='outlined' style={{}} sx={{ backgroundColor: 'var(--sipzee-red-2)', marginTop: '10px', marginLeft: '5px', marginRight: '5px' }} onClick={() => handleCloseAndPayClicked()}>Close & Pay</Button>
                                        : null
                                    }
                                    <Button variant='outlined' sx={{ backgroundColor: ('var(--sipzee-yellow)'), marginTop: '10px' }} onClick={() => openDialog('Cancel Order')}>Cancel Order</Button>
                                </td>

                            </tr>
                            : null
                        }

                       
                    </tbody>
                </table>

                <table className='SummaryTable'>
                    <tbody>
                        <tr>
                            <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                        </tr>
                        <tr>

                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <SentimentSatisfiedAltIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} style={{ alignSelf: 'center' }} />
                                    <span style={{ alignSelf: 'center' }}>Customer Info</span>
                                    {order.Status === 'Open' ?
                                        <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Your Info')} >
                                            <EditIcon sx={{ color: 'var(--sipzee-yellow)' }} />
                                        </Fab>
                                        :
                                        <span></span>
                                    }
                                </div>

                            </td>
                        </tr>
                        <tr>
                            <td>Name:</td>
                            <td>{order.CustomerName} {order.CustomerLastname }</td>
                        </tr>

                        <tr>
                            <td>Phone:</td>
                            <td>{order.CustomerPhoneNum}</td>
                        </tr>
                        <tr>
                            <td>
                                Mobile Text Updates:
                            </td>
                            <td>
                                <StyledCheckbox checked={order.CustomerWantsTextMsg.toUpperCase() == 'TRUE'} />
                            </td>
                        </tr>
                        <tr>
                            <td>Email:</td>
                            <td>{order.CustomerEmail}</td>
                        </tr>

                    </tbody>
                </table>

                <table className='SummaryTable'>
                    <tbody>
                        <tr>
                            <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                        </tr>

                        <tr>
                  

                                <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {order.LocationType === 'Residence' ?
                                            <HomeIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} /> : <BusinessIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} />
                                        }
                                    <span style={{ alignSelf: 'center' }}>Address</span>
                                    {order.Status === 'Open' ?
                                        <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Address')} >
                                            <EditIcon sx={{ color: 'var(--sipzee-yellow)' }} />
                                        </Fab>
                                        :
                                        <span></span>
                                    }
                                    </div>

                                </td>
                   
                        </tr>
                        <tr>
                            <td>

                                Street:
                            </td>
                            <td>{order.CustomerAddress_Street}</td>
                        </tr>
                        {order.CustomerAddress_Apt_Suit_Other === '' ? null :
                            <tr>
                                <td>Apt/Suite:</td>
                                <td>{order.CustomerAddress_Apt_Suit_Other}</td>
                            </tr>
                        }

                        <tr>
                            <td>City:</td>
                            <td>{order.CustomerAddress_City}</td>
                        </tr>
                        <tr>
                            <td>State:</td>
                            <td>{order.CustomerAddress_State}</td>
                        </tr>
                        <tr>
                            <td>Zip:</td>
                            <td>{order.CustomerAddress_Zipcode}</td>
                        </tr>
                    </tbody>
                </table>
                {
                    order.LocationType !== 'Business' ? null :
                        buildBusinessHours()

                }
                <table className='SummaryTable SummaryFinancials'>
                    <tbody>
                        <tr>
                            <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                        </tr>

                        <tr>
            

                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>
                                        <Image src='images/payout.png' style={{ height: 'auto', width: '40px', maxWidth: '40px' }} />
                                    </div>
                                    <span style={{ alignSelf: 'center' }}>Financials</span>
                                    {order.Status === 'Open' ?
                                        <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Financials')}>
                                            <EditIcon sx={{ color: 'var(--sipzee-yellow)' }}  />
                                        </Fab>
                                        : <span></span>
                                    }
                                </div>

                            </td>
                        </tr>
                        <tr>
                            <td>Estimated Quantity:</td>
                            <td style={{ fontWeight: 'bold' }}>{order.Quantity_Of_Cans_Bottles}</td>
                        </tr>
                        <tr>
                            <td>Bottle value:</td>
                            <td>{formatter.format(order.Quantity_Of_Cans_Bottles * .1)}</td>
                        </tr>
                        <tr>
                            <td>Financial Processing Fee:</td>
                            <td>{formatter.format(order.ProcessingFee)}</td>
                        </tr>
                        {
                            parseFloat(order.TipAmount) > 0 ?
                            <tr>
                                <td>Tip:</td>
                                    <td>{formatter.format(parseFloat(order.TipAmount)) }</td>
                            </tr>
                            : null
                        }

                       <tr>
                            <td>
                                {order.Donation === null ? 'Customer will receive' : 'You are donating'}
                            </td>
                            <td>
                                {(order.CustomerPaymentMethod.toUpperCase() == "NO PAYMENT" ? '$0 and good vibes' : formatter.format(parseFloat(order.BottleValue) - parseFloat(order.ProcessingFee) - parseFloat(order.TipAmount)))}
                            </td>
                        </tr>
                           
                       
                        <tr>
                            <td>
                                {order.Donation === null ? 'Payment Method' : 'Organization'}
                            </td>
                            <td>
                                {order.Donation === null ? order.CustomerPaymentMethod : order.Donation.DonationTitle}
                            </td>
                        </tr>

                        {order.Donation === null ?
                            <tr>
                                <td>
                                    Pay to the order of:
                                </td>
                                <td>
                                    {order.CustomerCheckPayeeName}
                                </td>
                            </tr>
                            :
                            null
                        }

                    </tbody>
                </table>
                {containerDetails == '' ?
                    null :
                    <table className='SummaryTable'>
                        <tbody>
                            <tr>
                                <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                            </tr>

                            <tr>
                                <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>

                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div></div>
                                        <span style={{ alignSelf: 'center' }}>Estimated Quantities</span>
                                        {order.Status === 'Open' ?
                                            <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Estimator')} >
                                                <EditIcon sx={{ color: 'var(--sipzee-yellow)' }} />
                                            </Fab>
                                            :
                                            <span></span>
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='2' style={{ textAlign: 'center' }} >
                                    {containerDetails.map((container, containerIndex) => (
                                        <div style={{borderBottom:'1px solid #efefef', marginTop:'5px'} }>
                                            <EstimateItem key={'EstimateItem_' + containerIndex} container={container} />
                                        </div>
                                    ))}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                }   

                {order.CustomerSpecialInstructions === '' && selectedStores.length === 0 ?
                    null :
                    <table className='SummaryTable'>
                        <tbody>
                            <tr>
                                <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                            </tr>

                            <tr>
           
                                <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>

                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div></div>
                                        <span style={{ alignSelf: 'center' }}> Additional Info</span>
                                        {order.Status === 'Open' ?
                                            <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Special Instructions')}>
                                                <EditIcon sx={{ color: 'var(--sipzee-yellow)' }}  />
                                            </Fab>
                                            :
                                            <span></span>
                                        }
                                    </div>
                                </td>
                            </tr>
                            {order.CustomerSpecialInstructions === '' ? null :
                                <tr>
                                    <td>Special Instructions:</td>
                                    <td>{order.CustomerSpecialInstructions}</td>
                                </tr>
                            }
                            {selectedStores.length === 0 ?
                                null :
                                <>
                                    <tr >
                                        <td colSpan='2' style={{ fontWeight: 'normal',textAlign:'center' }}>Selected Stores:</td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2'>
                                            <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'center', width: '100%', minHeight: '35px' }}>
                                                {selectedStores}
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }
                        </tbody>
                    </table>
                }
                
                
                   
                    <table className='SummaryTable'>
                        <tbody>
                            <tr>
                                <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                            </tr>

                            <tr>

                                <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>

                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div></div>
                                        <span style={{ alignSelf: 'center' }}>Photos</span>
                                        {order.Status === 'Open' ?
                                            <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Photos')}>
                                                <EditIcon sx={{ color: 'var(--sipzee-yellow)' }} />
                                            </Fab>
                                            :
                                            <span></span>
                                        }
                                    </div>
                                </td>
                            </tr>
                            {order.CustomerPhotoDataBase64String === '' ?
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }} >
                                        No Photos
                                    </td>
                                </tr>
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }} >
                                        <img src={order.CustomerPhotoDataBase64String} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String2 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String2} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String3 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String3} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String4 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String4} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String5 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String5} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                
            </>
        )
    }

    function buildBusinessHours() {
        let hours = [];

        if (order.MonHours !== '') {
            let openHours = getHours(order.MonHours);
            hours.push(<tr key='MonHoursRow'><td>Mon </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.TueHours !== '') {
            let openHours = getHours(order.TueHours);
            hours.push(<tr key='TueHoursRow'><td>Tue </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.WedHours !== '') {
            let openHours = getHours(order.WedHours);
            hours.push(<tr key='WedHoursRow'><td>Wed </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.ThuHours !== '') {
            let openHours = getHours(order.ThuHours);
            hours.push(<tr key='ThuHoursRow'><td>Thu </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.FriHours !== '') {
            let openHours = getHours(order.FriHours);
            hours.push(<tr key='FriHoursRow'><td>Fri </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.SatHours !== '') {
            let openHours = getHours(order.SatHours);
            hours.push(<tr key='SatHoursRow'><td>Sat </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.SunHours !== '') {
            let openHours = getHours(order.SunHours);
            hours.push(<tr key='SunHoursRow'><td>Sun </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }

        return (<table className='SummaryTable'>
            <tbody>
                <tr>
                    <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                </tr>

                <tr>
                    <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <AccessTimeIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} />
                            <span style={{ alignSelf: 'center' }}>Business Hours</span>
                            {order.Status === 'Open' ?
                                <Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-gray-2)' }} onClick={() => openDialog('Business Hours')} >
                                    <EditIcon sx={{ color: 'var(--sipzee-yellow)' }} />
                                </Fab>
                                :
                                <span></span>
                            }
                        </div>
                    </td>
                </tr>
                {hours}
            </tbody>
        </table>
        );
    }

    function handleMessageAdded(chatMessage) {
        let clonedOrder = cloneDeep(order); // deep clone so the reference is updated and setLoggedInUser re-renders
        clonedOrder.ChatMessages.push(chatMessage);
        setOrder(clonedOrder);
        if (props.orderUpdated !== undefined) {
            props.orderUpdated(clonedOrder)
        }
    }

    function validateOrderStatus() {
        let isValid = true;
        if (dayjs(availableDate) < dayjs().startOf('day')) {
            isValid = false;
        }

        if (isValid) {
            order.CustomerDateAvailableForPickup = {
                Data: availableDate.format('MM/DD/YYYY')
            }
            updateOrder();
        }

       
    }

    function updateOrder() {
        closeDialog();
        setIsFetching(true);

        let postData = {
            updateRequest: JSON.stringify(order),
            notifyCustomer: notifyCustomerOnUpdate,
            notifyRecycler: notifyRecyclerOnUpdate
        }

        
        TokenService.adminServicePost(postData, 'PickupRequest_UpdateOrder', '')
            .then((response) => {
                if (response !== null) {
                    setIsFetching(false);
                    response = response[Object.keys(response)[0]];
                    if (response.Result === "SUCCESS") {
                        let requestData = JSON.parse(response.JsonData);

                        let orderTemp = JSON.parse(requestData.PickupRequest); 
                        setOrderData(orderTemp);
                        if (props.orderUpdated !== undefined) {
                            props.orderUpdated(orderTemp)
                        }
                        enqueueSnackbar('Your order has been updated', {
                            variant: 'success',
                        });
                    }
                    else if (response.Result === "FAIL") {

                        if (response.Message = 'Validation Errors') {
                            let errors = JSON.parse(response.JsonData);
                            let message = '';
                            for (let i = 0; i < errors.length; i++) {
                                message += errors[i] + "\r\n";
                            }
                            enqueueSnackbar(message, {
                                variant: 'error',
                            });
                        }
                        else {
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    }
                }
            })
            .catch((response) => {
                setIsFetching(false);
                if (response !== null) {
                    if (response.Result === "FAIL") {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    }

                }
            });

        
    }

    //#region Dialogs

    function closeDialog() {
        setShowDialog('')
    }

    function showDialogOrderStatus() {
        return (
            <Dialog
                open={true}
                onClose={closeDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Change your availability date
                </DialogTitle>
                <DialogContent>
                    <div>
                        When will your cans/bottles be available for pickup?
                    </div>
                    <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <StaticDatePicker
                                displayStaticWrapperAs="desktop"
                                value={availableDate}
                                minDate={dayjs()}
                                maxDate={dayjs().add(7, 'day')}
                                onChange={(newValue) => {
                                    setAvailableDate(newValue);
                                }}
                                views={['day']}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </div>
                    <div style={{ borderTop: '1px solid var(--sipzee-gray-2' }}>
                        <FormGroup>
                            <FormControlLabel control={<StyledCheckbox checked={notifyCustomerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(!notifyCustomerOnUpdate) }} />} label="Notify Customer" />
                            {props.order.Status_Reason === 'Scheduled' ?
                                <FormControlLabel control={<StyledCheckbox checked={notifyRecyclerOnUpdate} onChange={() => { setNotifyRecyclerOnUpdate(!notifyRecyclerOnUpdate) }} />} label="Notify Recyler" />
                                :
                                null
                            }

                            <FormControlLabel defaultChecked control={<StyledCheckbox checked={!notifyCustomerOnUpdate && !notifyRecyclerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(false); setNotifyRecyclerOnUpdate(false); }} />} label="Silent Update" />
                        </FormGroup>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog}>
                        Cancel
                    </Button>
                    <Button onClick={validateOrderStatus} autoFocus>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>)
    }

    function showDialogYourInfo() {
        return (
        <Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Edit Customer Info
            </DialogTitle>
            <DialogContent>
                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Name</span>

                        </div>
                        <div className={styles.ContactSectionBody}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['Firstname'] !== undefined} label="First Name" onChange={(e) => setCustomerFirstname(e.target.value)} value={customerFirstname} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Firstname'] !== undefined ? formValidation.errors['Firstname'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['Lastname'] !== undefined} label="Last Name" onChange={(e) => setCustomerLastname(e.target.value)} value={customerLastname} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Lastname'] !== undefined ? formValidation.errors['Lastname'] : ''}</div>
                        </div>
                    </div>

                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Phone Number</span>
                        </div>
                        <div className={styles.ContactSectionBody}>
                            <div style={{ display: 'flex', justifyContent: 'space-between',  flexDirection:'column' }}>
                                <TextField style={{ width: '200px', alignSelf: 'flex-start' }} className={styles.ContactSectionText} error={formValidation.errors['PhoneNumber'] !== undefined} label="Phone Number" onChange={(e) => setPhoneNumberChanged(e.target.value)} value={customerPhoneNumber} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />

                                <div style={{ textAlign: 'center', alignSelf: 'flex-start', marginTop: '15px', display:'flex' }}>

                                    <StyledCheckbox style={{ marginTop: '-15px' }} checked={hasMobileUpdates} onChange={(e) => setHasMobileUpdates(e.target.checked)} />
                                    <div>
                                        Receive Text Updates?
                                    </div>
                                </div>
                            </div>
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['PhoneNumber'] !== undefined ? formValidation.errors['PhoneNumber'] : ''}</div>
                        </div>
                       
                        <div className={styles.ContactSectionBody}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['Email'] !== undefined} label="Email" onChange={(e) => setCustomerEmail(e.target.value)} value={customerEmail} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['EmailAddress'] !== undefined ? formValidation.errors['EmailAddress'] : ''}</div>
                        </div>
                       
                    </div>
                    <div style={{borderTop:'1px solid var(--sipzee-gray-2'} }>
                        <FormGroup>
                            <FormControlLabel control={<StyledCheckbox checked={notifyCustomerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(!notifyCustomerOnUpdate) }} />} label="Notify Customer" />
                            {props.order.Status_Reason === 'Scheduled' ?
                                <FormControlLabel control={<StyledCheckbox checked={notifyRecyclerOnUpdate} onChange={() => { setNotifyRecyclerOnUpdate(!notifyRecyclerOnUpdate) }} />} label="Notify Recyler" />
                                :
                                null
                            }

                            <FormControlLabel defaultChecked control={<StyledCheckbox checked={!notifyCustomerOnUpdate && !notifyRecyclerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(false); setNotifyRecyclerOnUpdate(false); }} />} label="Silent Update" />
                        </FormGroup>
                    </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} autoFocus>
                    Cancel
                </Button>
                <Button onClick={validateYourInfo} autoFocus>
                    Save
                </Button>
            </DialogActions>
        </Dialog>)
    }

    function setPhoneNumberChanged(val) {
        let phone = normalizePhoneNumber(val, prevCustomerPhoneNumber.current);
        setCustomerPhoneNumber(phone);
    }
    function normalizePhoneNumber(value, previousValue) {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        //if (!previousValue)// || value.length > previousValue.length)
        {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    function validateYourInfo() {
        let isValid = true;
     
        let errors = [];
        if (customerFirstname.trim() == '') {
            errors["Firstname"] = "Missing your First Name";
            isValid = false;
        }

        if (customerLastname.trim() == '') {
            errors["Lastname"] = "Missing your Last Name";
            isValid = false;
        }

        if (customerPhoneNumber.trim() === '') {
            errors["PhoneNumber"] = "Please enter your phone number";
            isValid = false;
        }
        else if (customerPhoneNumber.trim().length !== 14) {
            errors["PhoneNumber"] = "Enter your 10 digit phone number";
            isValid = false;
        }

        if (customerEmail.trim() === '') {
            errors["EmailAddress"] = "Missing your Email";
            isValid = false;
        }
        else {
            if (!isValidEmail(customerEmail.trim())) {
                isValid = false;
                errors["EmailAddress"] = "Not a valid email.";
            }
            else {
                if (customerEmail.trim().toLowerCase().indexOf('@gmail.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@gmail.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @gmail.com?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@yahoo.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@yahoo.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @yahoo.com?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@hotmail.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@hotmail.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @hotmail.com?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@aol.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@aol.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @aol.com?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@comcast.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@comcast.net') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @comcast.net?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@sbcglobal.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@sbcglobal.net') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @sbcglobal.net?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@icloud.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@icloud.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @icloud.com?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@outlook.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@outlook.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @outlook.com?";
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@msn.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@msn.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @msn.com?";
                }

            }
        }

        if (isValid) {
            order.CustomerName = customerFirstname.trim();
            order.CustomerLastname = customerLastname.trim();
            order.CustomerPhoneNum = customerPhoneNumber.trim();
            order.CustomerEmail = customerEmail.trim();
            order.CustomerWantsTextMsg = hasMobileUpdates ? 'True' : 'False';
            updateOrder();
        }
        else {
            setFormValidation({
                errors: errors,
                isValid: false
            })
        }
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    function showDialogAddress() {
        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Edit Address
            </DialogTitle>
            <DialogContent>
                <div className={styles.ContactSection}>
                
                    <div className={styles.ContactSectionBody} style={{marginTop:'10px'} }>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressStreet'] !== undefined} label="Street" onChange={(e) => setCustomerAddressStreet(e.target.value)} value={customerAddressStreet} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressStreet'] !== undefined ? formValidation.errors['CustomerAddressStreet'] : ''}</div>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressStreet2'] !== undefined} label="Apt/Suite/Other" onChange={(e) => setCustomerAddressStreet2(e.target.value)} value={customerAddressStreet2} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressStreet2'] !== undefined ? formValidation.errors['CustomerAddressStreet2'] : ''}</div>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressCity'] !== undefined} label="City" onChange={(e) => setCustomerAddressCity(e.target.value)} value={customerAddressCity} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressCity'] !== undefined ? formValidation.errors['CustomerAddressCity'] : ''}</div>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressState'] !== undefined} label="State" onChange={(e) => setCustomerAddressState(e.target.value)} value={customerAddressState} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressState'] !== undefined ? formValidation.errors['CustomerAddressState'] : ''}</div>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressZip'] !== undefined} label="Zip" onChange={(e) => setCustomerAddressZip(e.target.value)} value={customerAddressZip} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressZip'] !== undefined ? formValidation.errors['CustomerAddressZip'] : ''}</div>
                    </div>
                </div>
                <div style={{ borderTop: '1px solid var(--sipzee-gray-2' }}>
                    <FormGroup>
                        <FormControlLabel control={<StyledCheckbox checked={notifyCustomerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(!notifyCustomerOnUpdate) }} />} label="Notify Customer" />
                        {props.order.Status_Reason === 'Scheduled' ?
                            <FormControlLabel control={<StyledCheckbox checked={notifyRecyclerOnUpdate} onChange={() => { setNotifyRecyclerOnUpdate(!notifyRecyclerOnUpdate) }} />} label="Notify Recyler" />
                            :
                            null
                        }

                        <FormControlLabel defaultChecked control={<StyledCheckbox checked={!notifyCustomerOnUpdate && !notifyRecyclerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(false); setNotifyRecyclerOnUpdate(false); }} />} label="Silent Update" />
                    </FormGroup>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} autoFocus>
                    Cancel
                </Button>
                <Button onClick={validateAddress} autoFocus>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
        )
    }

    function validateAddress() {
        let isValid = true;

        let errors = [];
        if (customerAddressStreet.trim() === '') {
              errors["CustomerAddressStreet"] = "Please enter your Street";
            isValid = false;
        }

        if (customerAddressCity.trim() === '') {
            errors["CustomerAddressCity"] = "Please enter your City";
            isValid = false;
        }

        if (customerAddressState.trim() === '') {
            errors["CustomerAddressState"] = "Please enter your State";
            isValid = false;
        }

        if (customerAddressZip.trim() === '') {
            errors["CustomerAddressZip"] = "Please enter your Zip Code";
            isValid = false;
        }

        if (isValid) {
            order.CustomerAddress_Street = customerAddressStreet;
            order.CustomerAddress_Apt_Suit_Other = customerAddressStreet2;
            order.CustomerAddress_City = customerAddressCity;
            order.CustomerAddress_State = customerAddressState;
            order.CustomerAddress_Zipcode = customerAddressZip;
            updateOrder();
        }
    }
    
    function showDialogFinancials() {
        let usedEstimator = order.Returnable_Type_Container_Detail_JSON !== '';
        
            // customer used Actual Quantity? They can edit the quantity here
            
     
            // customer used Estimator
            // they can only change Payment Method and Pay to the Order of
            // they will need to use the Edit Estimated Quantities to change the quantity
       
        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <>
                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Quantity</span>

                        </div>
                        {usedEstimator ?
                                <div className={styles.ContactSectionBody}>
                                    Changes to the containers can be made in the 'Estimated Quantities' section...
                                </div>
                            :
                            <div className={styles.ContactSectionBody}>
                                <TextField className={styles.ContactSectionText} error={formValidation.errors['Quantity'] !== undefined} label="" onChange={(e) => setQuantity(e.target.value)} value={quantity} variant="outlined" />
                                <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Quantity'] !== undefined ? formValidation.errors['Quantity'] : ''}</div>
                            </div>
                        }
                        
                    </div>
                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Payment Info</span>
                        </div>
                        <div >
                            <PaymentOptions pickupData={{ ZipCodeInfo: { Zipcode: order.CustomerAddress_Zipcode } }} pickupRequest={order} onChanged={(paymentType) => handlePaymentTypeChanged(paymentType)} />
                        </div>
                        {(customerPaymentMethod === 'Digital Check' || customerPaymentMethod === 'Mailed Check') ?
                            <div className={styles.ContactSectionBody}>
                                <TextField className={styles.ContactSectionText} error={formValidation.errors['CheckPayee'] !== undefined} label="Pay to the order of" onChange={(e) => setCustomerCheckPayeeName(e.target.value)} value={customerCheckPayeeName} variant="outlined" />
                                <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CheckPayee'] !== undefined ? formValidation.errors['CheckPayee'] : ''}</div>
                            </div>
                            : null
                        }
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '10px' }}>
                            <div style={{ alignSelf: 'center' }}>Tip Amount: {formatter.format(tipAmount)}</div>

                            <div>
                                <Fab onClick={(e) => setShowTipAmountPrompt(true)} size={'small'} sx={{ backgroundColor: 'var(--sipzee-green)' }}>
                                    <AddIcon />
                                </Fab>
                            </div>
                        </div>
                        {showTipAmountPrompt ?
                            <TipPrompt pickupRequest={order} paymentToCustomer={(parseFloat(order.BottleValue) - parseFloat(order.ProcessingFee)).toString()} onClose={(e) => setShowTipAmountPrompt(false)} onAccept={(amount) => handleTipAccepted(amount)} />
                            :
                            null
                        }
                        <div style={{ borderTop: '1px solid var(--sipzee-gray-2' }}>
                            <FormGroup>
                                <FormControlLabel control={<StyledCheckbox checked={notifyCustomerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(!notifyCustomerOnUpdate) }} />} label="Notify Customer" />
                                {props.order.Status_Reason === 'Scheduled' ?
                                    <FormControlLabel control={<StyledCheckbox checked={notifyRecyclerOnUpdate} onChange={() => { setNotifyRecyclerOnUpdate(!notifyRecyclerOnUpdate) }} />} label="Notify Recyler" />
                                    :
                                    null
                                }

                                <FormControlLabel defaultChecked control={<StyledCheckbox checked={!notifyCustomerOnUpdate && !notifyRecyclerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(false); setNotifyRecyclerOnUpdate(false); }} />} label="Silent Update" />
                            </FormGroup>
                        </div>

                    </div>
                </>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} autoFocus>
                    Cancel
                </Button>
                <Button onClick={validateFinancials} autoFocus>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
        )
    }

    function handlePaymentTypeChanged(paymentType, donation) {
        setCustomerPaymentMethod(paymentType);
    }

    function validateFinancials() {
        let usedEstimator = order.Returnable_Type_Container_Detail_JSON !== '';
            // validate with Actual Quantity
            let isValid = true;


            let errors = {};
        if (!usedEstimator) {


            if (typeof quantity === 'string') {

                if (quantity.trim() == '') {
                    errors["Quantity"] = "Quantity is required.";
                    isValid = false;
                }
                else {
                    if (isNaN(quantity)) {

                        errors["Quantity"] = "Quantity must be a number.";
                        isValid = false;
                    }
                    else if (parseInt(quantity) <= 0) {

                        errors["Quantity"] = "Quantity must be more than zero.";
                        isValid = false;
                    }
                    //else if (parseInt(quantity) > 2000) {
                    //    let message = 'Maximum is 2,000.';
                    //    errors["Quantity"] = message;
                    //    isValid = false;
                    //}
                    //else if (parseInt(quantity) < 75) {
                    //    let message = 'Minimum is 75.';
                    //    errors["Quantity"] = message;
                    //    isValid = false;
                    //}
                }
            }
            else {
                if (parseInt(quantity) <= 0) {
                    errors["Quantity"] = "Quantity must be more than zero.";
                    isValid = false;
                }
                //else if (parseInt(quantity) > 2000) {
                //    let message = 'Maximum is 2,000.';
                //    errors["Quantity"] = message;
                //    isValid = false;
                //}
                //else if (parseInt(quantity) < 75) {
                //    let message = 'Minimum is 75.';
                //    errors["Quantity"] = message;
                //    isValid = false;
                //}
            }
        }

            if (customerPaymentMethod === 'Digital Check' || customerPaymentMethod === 'Mailed Check') {
                if (customerCheckPayeeName.trim() === '') {
                    errors["CheckPayee"] = "Who do we make the check out to?";
                    isValid = false;
                }
            }

            if (isValid) {
                order.CustomerPaymentMethod = customerPaymentMethod;

                if (customerPaymentMethod === 'Digital Check' || customerPaymentMethod === 'Mailed Check') {
                    order.CustomerCheckPayeeName = customerCheckPayeeName;
                }
               
                if (!usedEstimator) {
                    order.Quantity_Of_Cans_Bottles = quantity;
                }
                
                order.TipAmount = tipAmount;
                updateOrder();
            }
            else {
                setFormValidation({
                    errors: errors,
                    isValid: false
                })
            }
      
    }

    function handleTipAccepted(amount) {
        setTipAmount(amount);
        setShowTipAmountPrompt(false);
    }
    
    function handleUpdateSpecialInstructions(selectedStores, otherStore) {
        order.CustomerSpecialInstructions = specialInstructions;
        order.SelectedStores = selectedStores;
        if (otherStore !== undefined) {
            if (otherStore.trim().length > 0) {
                order.SelectedStores.push(otherStore.trim());
            }
        }

        order.SelectedStores = [...new Set(order.SelectedStores)]; // removes duplicates

        updateOrder();

    }

    function showDialogSpecialInstructions() {
        let orderCopy = cloneDeep(order);
        let otherStores = [];
        let existingStores = RetailStores.getStores();

        for (let i = 0; i < orderCopy.SelectedStores.length; i++) { 
            let storeFound = false;
            for (let exstIndex = 0; exstIndex < existingStores.length; exstIndex++) {
                if (existingStores[exstIndex].value.toUpperCase() == orderCopy.SelectedStores[i].toUpperCase()) {
                    storeFound = true;
                    break;
                }
            }
            if (!storeFound) {
                orderCopy.OtherStore = orderCopy.SelectedStores[i];
            }
        }


        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Edit Special Instructions
            </DialogTitle>
            <DialogContent>
                <div>
                    <div style={{display:'flex', justifyContent:'center'} }>
                        <TextField multiline label="Special Instructions" variant="filled" style={{ backgroundColor: 'white', flex: 1, minWidth: '300px' }} rows={4}
                            value={specialInstructions} onChange={(e) => setSpecialInstructions(e.target.value)}
                        />
                    </div>
                    <div>
                        <StoreSelection pickupRequest={orderCopy} onBack={closeDialog} onUpdated={(selectedStores, otherStore) => handleUpdateSpecialInstructions(selectedStores, otherStore)} />
                    </div>
                </div>
            </DialogContent>
        </Dialog>)

    }

    function showDialogBusinessHours() {
        let orderTemp = cloneDeep(order);
        orderTemp.hasMondayHours = orderTemp.MonHours !== '';
        if (orderTemp.hasMondayHours) {
                
            let hours = getHours(orderTemp.MonHours);
            orderTemp.mondayHoursStart = hours.start;
            orderTemp.mondayHoursEnd = hours.end;
        }
        else {
            orderTemp.mondayHoursStart = undefined;
            orderTemp.mondayHoursEnd = undefined;
        }

        orderTemp.hasTuesdayHours = orderTemp.TueHours !== '';
        if (orderTemp.hasTuesdayHours) {
            let hours = getHours(orderTemp.TueHours);
            orderTemp.tuesdayHoursStart = hours.start;
            orderTemp.tuesdayHoursEnd = hours.end;
        }
        else {
            orderTemp.tuesdayHoursStart = undefined;
            orderTemp.tuesdayHoursEnd = undefined;
        }

        orderTemp.hasWednesdayHours = orderTemp.WedHours !== '';
        if (orderTemp.hasWednesdayHours) {
            let hours = getHours(orderTemp.WedHours);
            orderTemp.wednesdayHoursStart = hours.start;
            orderTemp.wednesdayHoursEnd = hours.end;
        }
        else {
            orderTemp.wednesdayHoursStart = undefined;
            orderTemp.wednesdayHoursEnd = undefined;
        }

        orderTemp.hasThursdayHours = orderTemp.ThuHours !== '';
        if (orderTemp.hasThursdayHours) {
            let hours = getHours(orderTemp.ThuHours);
            orderTemp.thursdayHoursStart = hours.start;
            orderTemp.thursdayHoursEnd = hours.end;
        }
        else {
            orderTemp.thursdayHoursStart = undefined;
            orderTemp.thursdayHoursEnd = undefined;
        }

        orderTemp.hasFridayHours = orderTemp.FriHours !== '';
        if (orderTemp.hasFridayHours) {
            let hours = getHours(orderTemp.FriHours);
            orderTemp.fridayHoursStart = hours.start;
            orderTemp.fridayHoursEnd = hours.end;
        }
        else {
            orderTemp.fridayHoursStart = undefined;
            orderTemp.fridayHoursEnd = undefined;
        }

        orderTemp.hasSaturdayHours = orderTemp.SatHours !== '';
        if (orderTemp.hasSaturdayHours) {
            let hours = getHours(orderTemp.SatHours);
            orderTemp.saturdayHoursStart = hours.start;
            orderTemp.saturdayHoursEnd = hours.end;
        }
        else {
            orderTemp.saturdayHoursStart = undefined;
            orderTemp.saturdayHoursEnd = undefined;
        }

        orderTemp.hasSundayHours = orderTemp.SunHours !== '';
        if (orderTemp.hasSundayHours) {
            let hours = getHours(orderTemp.SunHours);
            orderTemp.sundayHoursStart = hours.start;
            orderTemp.sundayHoursEnd = hours.end;
        }
        else {
            orderTemp.sundayHoursStart = undefined;
            orderTemp.sundayHoursEnd = undefined;
        }

        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          
            <DialogContent>
                <BusinessHours pickupRequest={orderTemp} onCancel={closeDialog} onNext={BusinessHours_OnAccepted} />
            </DialogContent>
           
        </Dialog>
        )
    }

    function getHours(hourString) {
        let startHours = hourString.split(' to ')[0];
        let endHours = hourString.split(' to ')[1];
        let openingTime = dayjs().set('hour', parseInt(startHours.split(':')[0])).set('minute', parseInt(startHours.split(':')[1])).set('second', 0);
        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
        return { start: openingTime, end: closingTime }
        
    }

    function BusinessHours_OnAccepted(hasMondayHours, mondayHoursStart, mondayHoursEnd,
        hasTuesdayHours, tuesdayHoursStart, tuesdayHoursEnd,
        hasWednesdayHours, wednesdayHoursStart, wednesdayHoursEnd,
        hasThursdayHours, thursdayHoursStart, thursdayHoursEnd,
        hasFridayHours, fridayHoursStart, fridayHoursEnd,
        hasSaturdayHours, saturdayHoursStart, saturdayHoursEnd,
        hasSundayHours, sundayHoursStart, sundayHoursEnd) {
      
        if (hasMondayHours) {
            order.MonHours = mondayHoursStart.format('HH:mm') + ' to ' + mondayHoursEnd.format('HH:mm');
        }
        else {
            order.MonHours = '';
        }

        if (hasTuesdayHours) {
            order.TueHours = tuesdayHoursStart.format('HH:mm') + ' to ' + tuesdayHoursEnd.format('HH:mm');
        }
        else {
            order.TueHours = '';
        }

        if (hasWednesdayHours) {
            order.WedHours = wednesdayHoursStart.format('HH:mm') + ' to ' + wednesdayHoursEnd.format('HH:mm');
        }
        else {
            order.WedHours = '';
        }

        if (hasThursdayHours) {
            order.ThuHours = thursdayHoursStart.format('HH:mm') + ' to ' + thursdayHoursEnd.format('HH:mm');
        }
        else {
            order.ThuHours = '';
        }

        if (hasFridayHours) {
            order.FriHours = fridayHoursStart.format('HH:mm') + ' to ' + fridayHoursEnd.format('HH:mm');
        }
        else {
            order.FriHours = '';
        }

        if (hasSaturdayHours) {
            order.SatHours = saturdayHoursStart.format('HH:mm') + ' to ' + saturdayHoursEnd.format('HH:mm');
        }
        else {
            order.SatHours = '';
        }

        if (hasSundayHours) {
            order.SunHours = sundayHoursStart.format('HH:mm') + ' to ' + sundayHoursEnd.format('HH:mm');
        }
        else {
            order.SunHours = '';
        }

        updateOrder();
    }

   
    function showDialogEstimator() {
     
        let tempOrder = cloneDeep(order);
        tempOrder.Containers = formatContainersFromJson();
        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Estimator
            </DialogTitle>
            <DialogContent>
                <div style={{textAlign:'center'} }>
                    <EstimateSummary pickupRequest={tempOrder} onBack={closeDialog} onUpdated={(containers, estimatedQuantity) => handleEstimatedUpdated(containers, estimatedQuantity)} showNotificationOptions={true} />
                    {formValidation.errors['UpdatedEstimate'] === undefined ?
                        null
                        :
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['UpdatedEstimate'] !== undefined ? formValidation.errors['UpdatedEstimate'] : ''}</div>
                    }
                 
                  
                </div>
            </DialogContent>
        </Dialog>
        )
    }

    function handleEstimatedUpdated(containers, estimatedQuantity) {
        if (validateUpdatedEstimate(containers, estimatedQuantity).isValid) {
            let formattedContainers = formatContainersToJson(containers);
            order.Returnable_Type_Container_Detail_JSON = formattedContainers;
            order.Quantity_Of_Cans_Bottles = estimatedQuantity;
            updateOrder();
            closeDialog();
        }
        
    }

    function validateUpdatedEstimate(containers, estimatedQuantity) {

        let isValid = true;
        let errors = [];

        //if (parseInt(estimatedQuantity) <= 75) {
        //    errors["UpdatedEstimate"] = "The quantity cannot be less than 75.";
        //    isValid = false;
        //}

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function formatContainersFromJson() {
        let formattedContainers = [];
        let containerDetailJSON = order.Returnable_Type_Container_Detail_JSON;

        if (typeof containerDetailJSON === 'string') {
            containerDetailJSON = JSON.parse(containerDetailJSON);
        }

        
        for (let i = 0; i < containerDetailJSON.length; i++) {
            let item = containerDetailJSON[i];
            let formattedItem = {
                Id:i,
                containerType: '',
                containerSize:'',
                containerFullness: item.Fullness.replace("%",""),
                customPackQuantity:'',
                quantity: item.Quantity,
                returnableCount: item.ReturnableCount,
                contentsCans: false,
                contentsBottles: false,
                contentsLargerCansBottles: false,
                contents2Liters:false

            }
            if (item.ContainerName == 'Plastic Grocery') {
                formattedItem.containerType = 'Plastic Grocery Bag';
            }
            else if (item.ContainerName.trim().indexOf('Paper Grocery') > -1) {
                formattedItem.containerType = 'Paper Grocery Bag';
            }
            else if (item.ContainerName.trim().indexOf('Sml Garbage') > -1) {
                formattedItem.containerType = 'Garbage Bag';
                formattedItem.containerSize = 'Small';
            }
            else if (item.ContainerName.trim().indexOf('Med Garbage') > -1) {
                formattedItem.containerType = 'Garbage Bag';
                formattedItem.containerSize = 'Medium';
            }
            else if (item.ContainerName.trim().indexOf('XLg Garbage') > -1) {
                formattedItem.containerType = 'Garbage Bag';
                formattedItem.containerSize = 'XLarge';
            }
            else if (item.ContainerName.trim().indexOf('Lg Garbage') > -1) {
                formattedItem.containerType = 'Garbage Bag';
                formattedItem.containerSize = 'Large';
            }
         
            else if (item.ContainerName.toLowerCase().indexOf('pack') > -1) {
                // set pack size
                formattedItem.containerType = 'Original Package';
                formattedItem.containerSize = item.ContainerName;;
            }
            else if (item.ContainerName.trim() == 'Custom') {
                formattedItem.containerType = 'Custom Container'
                formattedItem.customPackQuantity = item.ReturnableCount;
                formattedItem.containerSize = item.ReturnableCount;
            }

            let contents = item.Description.split(',');
            for (let j = 0; j < contents.length; j++) {
                if (contents[j].trim() == '12 Oz Cans') {
                    formattedItem.contentsCans = true;
                }
                else if (contents[j].trim() == '12 Oz Bottles') {
                    formattedItem.contentsBottles = true;
                }
                else if (contents[j].trim() == 'Larger Cans & Bottles') {
                    formattedItem.contentsLargerCansBottles = true;
                }
                else if (contents[j].trim() == '2 Liter Bottles') {
                    formattedItem.contents2Liters = true;
                }
            }
            formattedItem.summary = buildSummary(formattedItem);
            formattedContainers.push(formattedItem);
        }

        return formattedContainers;
    }


    function formatContainersToJson(containers) {
        // copied from PickupWizard.jsx
        let formattedContainers = [];

        for (let i = 0; i < containers.length; i++) {
            let containerName = '';
            if (containers[i].containerType === 'Plastic Grocery Bag') {
                containerName = 'Plastic Grocery';
            }
            else if (containers[i].containerType === 'Paper Grocery Bag') {
                containerName = 'Paper Grocery';
            }
            else if (containers[i].containerType === 'Garbage Bag') {
                if (containers[i].containerSize === 'Small') {
                    containerName = 'Sml Garbage';
                }
                else if (containers[i].containerSize === 'Medium') {
                    containerName = 'Med Garbage Bag'
                }
                else if (containers[i].containerSize === 'Large') {
                    containerName = 'Lg Garbage Bag'
                }
                else if (containers[i].containerSize === 'XLarge') {
                    containerName = 'XLg Garbage Bag'
                }
            }
            else if (containers[i].containerType === 'Original Package') {
                if (containers[i].containerSize === 'otherpack') {
                    containerName = containers[i].customPackQuantity + ' Pack';
                }
                else {
                    containerName = containers[i].containerSize;
                }

            }
            else if (containers[i].containerType === 'Custom Container') {
                containerName = 'Custom';
            }

            let contents = [];

            if (containers[i].contentsCans) {
                contents.push('12 Oz Cans')
            }
            if (containers[i].contentsBottles) {
                contents.push('12 Oz Bottles')
            }
            if (containers[i].contentsLargerCansBottles) {
                contents.push('Larger Cans & Bottles')
            }
            if (containers[i].contents2Liters) {
                contents.push('2 Liter Bottles')
            }



            formattedContainers.push({
                Quantity: containers[i].quantity,
                ContainerName: containerName,
                Fullness: containers[i].containerFullness.toString() + '%',
                ReturnableCount: containers[i].returnableCount,
                Description: contents.length > 0 ? contents.join(', ') : ''

            });

        }
        return formattedContainers;
    }

    function buildSummary(formattedItem) {
        let fullnessDesc = null;
        let containerDesc = null;
        let contentsCansDesc = null;
        let contentsBottlesDesc = null;
        let contentsLargerDesc = null;
        let contents2LitersDesc = null;

        if (formattedItem.containerType == 'Plastic Grocery Bag' || formattedItem.containerType == 'Paper Grocery Bag' || formattedItem.containerType == 'Garbage Bag') {
            if (formattedItem.contentsCans) {
                contentsCansDesc = <div style={{ marginLeft: '20px' }}>12 oz cans</div>;
            }

            if (formattedItem.contentsBottles) {
                contentsBottlesDesc = <div style={{ marginLeft: '20px' }}>12 oz bottles</div>;
            }

            if (formattedItem.contentsLargerCansBottles) {
                contentsLargerDesc = <div style={{ marginLeft: '20px' }}>Larger cans/bottles</div>;
            }

            if (formattedItem.contents2Liters) {
                contents2LitersDesc = <div style={{ marginLeft: '20px' }}>2 Liter bottles</div>;
            }

            fullnessDesc = (
                <>
                    {(formattedItem.containerType === 'Garbage Bag' ? formattedItem.containerSize : '')} {formattedItem.containerType} of:
                </>
            );

        }
        else if (formattedItem.containerType === 'Original Package') {
            if (formattedItem.containerSize === 'otherpack') {
                containerDesc = <div>{formattedItem.containerSize} Pack</div>
            }
            else {
                containerDesc = <div>{formattedItem.containerSize}</div>
            }

        }
        else if (formattedItem.containerType.toLowerCase().indexOf('pack') > -1) {
            containerDesc = <div>{formattedItem.containerType}</div>
        }
        else if (formattedItem.containerType === 'Custom Container') {
            containerDesc = <div>Custom container of {parseInt(formattedItem.containerSize)} bottles/cans</div>
        }
        else {
            if (1 == 1) {

            }
        }

        return (
            <div>


                {containerDesc}
                {fullnessDesc}
                {contentsCansDesc}
                {contentsBottlesDesc}
                {contentsLargerDesc}
                {contents2LitersDesc}
            </div>
        )
    }

    function handleExtendExpiration() {
        let expirationDate = dayjs().add(1, 'week');
        order.ExpirationDateTimeUTC = {
            Data: expirationDate.format('MM/DD/YYYY hh:mm:ss a')
        }
        updateOrder();
        closeDialog();
    }
    function showDialogExtendTime() {
        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Extend Time
            </DialogTitle>
            <DialogContent>
               Would you like to extend your expiration date to 1 week from today?
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} autoFocus>
                    Cancel
                </Button>
                <Button onClick={handleExtendExpiration} autoFocus>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
        )
    }

    function validateCancelOrder() {

        let isValid = true;
        let errors = [];

        if (unscheduleReason === '') {
            errors["CancelReason"] = "Please select a reason";
            isValid = false;
        }
        else if (unscheduleReason === 'Other' && unscheduleReasonOther.trim() === '') {
            errors["CancelReason"] = "Please give us a few details";
            isValid = false;
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function validateAndCloseCancelOrder() {

        if (validateCancelOrder().isValid) {
            let reason = '';
            if (unscheduleReason === 'Other') {
                reason = unscheduleReasonOther.trim();
            }
            else {
                reason = unscheduleReason;
            }

            //CancelOrder(string CancelReason, string OrderGUID)
            closeDialog();
            setIsFetching(true);

            let postData = {
                CancelReason: reason,
                OrderGUID: order.OrderGUID,
                notifyCustomer: notifyCustomerOnUpdate,
                notifyRecycler: notifyRecyclerOnUpdate
            }


            TokenService.adminServicePost(postData, 'CancelOrder', '')
                .then((response) => {
                    if (response !== null) {
                        setIsFetching(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            //let requestData = JSON.parse(response.JsonData);

                            setOrder(response);
                            if (props.orderUpdated !== undefined) {
                                props.orderUpdated(response)
                            }
                            enqueueSnackbar('This order has been cancelled', {
                                variant: 'success',
                            });
                        }
                        else if (response.Result === "FAIL") {

                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    }
                })
                .catch((response) => {
                    setIsFetching(false);
                    if (response !== null) {
                        if (response.Result === "FAIL") {
                            enqueueSnackbar('Oops, something went wrong', {
                                variant: 'error',
                            });
                        }

                    }
                });

        }
    }

    function handleUnscheduleReasonChanged(e) {
        setUnscheduleReason(e.target.value);
    }

    function handleOtherChange(e) {
        setUnscheduleReasonOther(e.target.value);

    }
    function showDialogCancelOrder() {
        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <div style={{ display: 'flex' }}><SentimentDissatisfiedIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30, marginRight: '5px' }} /><div style={{ alignSelf: 'center' }}>Are you sure you want to cancel your pickup request?</div></div>
            </DialogTitle>
            <DialogContent>
                <div>
                  
                    <div style={{ marginTop: '15px', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ alignSelf: 'center' }}>
                            <FormControl variant="filled" sx={{ maxWidth: '300px', minWidth: '250px' }}>
                                <InputLabel id="demo-simple-select-filled-label">Cancel Reason</InputLabel>
                                <Select
                                    labelId="demo-simple-select-filled-label"
                                    id="demo-simple-select-filled"
                                   
                                    value={unscheduleReason}
                                    onChange={handleUnscheduleReasonChanged}
                                    label={unscheduleReason}
                                >
                                   
                                    <MenuItem value={'Cans are no longer available'}>Cans are no longer available</MenuItem>
                                    <MenuItem value={"I'll return them myself"}>I'll return them myself</MenuItem>
                                    <MenuItem value={'Nobody will pick them up'}>Nobody will pick them up</MenuItem>
                                    <MenuItem value={'Other'}>Other</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        {unscheduleReason === 'Other' ?
                            <div style={{ marginTop: '5px', alignSelf: 'center' }}>
                                <TextField onChange={handleOtherChange} placeholder={'Cancel reason'} value={unscheduleReasonOther} variant="outlined" style={{ maxWidth: '300px', minWidth: '250px' }} />
                            </div>
                            : null
                        }
                        <div style={{ borderTop: '1px solid var(--sipzee-gray-2' }}>
                            <FormGroup>
                                <FormControlLabel control={<StyledCheckbox checked={notifyCustomerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(!notifyCustomerOnUpdate) }} />} label="Notify Customer" />
                                {props.order.Status_Reason === 'Scheduled' ?
                                    <FormControlLabel control={<StyledCheckbox checked={notifyRecyclerOnUpdate} onChange={() => { setNotifyRecyclerOnUpdate(!notifyRecyclerOnUpdate) }} />} label="Notify Recyler" />
                                    :
                                    null
                                }

                                <FormControlLabel defaultChecked control={<StyledCheckbox checked={!notifyCustomerOnUpdate && !notifyRecyclerOnUpdate} onChange={() => { setNotifyCustomerOnUpdate(false); setNotifyRecyclerOnUpdate(false); }} />} label="Silent Update" />
                            </FormGroup>
                        </div>
                        {!formValidation.isValid ?
                            <div style={{ color: 'var(--sipzee-red)' }}>
                                {formValidation.errors["CancelReason"] == undefined ? null : formValidation.errors["CancelReason"]}
                            </div>
                            : null}


                    </div>
                </div>

            </DialogContent>
            <DialogActions>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button onClick={closeDialog}>
                        Back
                    </Button>
                    <Button onClick={validateAndCloseCancelOrder} variant="contained" autoFocus>
                        Cancel Order
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
        )
    }

    function handleUploadImageClick(event) {
        let file = event.target.files[0];
        const reader = new FileReader();
        var url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {


            // resize the imagage
            var img = document.createElement("img");
            img.onload = function (event) {
                var MAX_WIDTH = 1024;
                var MAX_HEIGHT = 1024;

                var width = img.width;
                var height = img.height;

                // Change the resizing logic
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                // Actual resizing
                ctx.drawImage(img, 0, 0, width, height);



                // Show resized image in preview element
                var dataurl = canvas.toDataURL(file.type);

                if (customerPhotoDataBase64String == '') {
                    setCustomerPhotoDataBase64String(dataurl);
                }
                else if (customerPhotoDataBase64String2 == '') {
                    setCustomerPhotoDataBase64String2(dataurl);
                }
                else if (customerPhotoDataBase64String3 == '') {
                    setCustomerPhotoDataBase64String3(dataurl);
                }
                else if (customerPhotoDataBase64String4 == '') {
                    setCustomerPhotoDataBase64String4(dataurl);
                }
                else if (customerPhotoDataBase64String5 == '') {
                    setCustomerPhotoDataBase64String5(dataurl);
                }
            }
            img.src = reader.result;


        }.bind(this);
    };

    function removeImage(imageNumber) {
        if (imageNumber == 1) {
            // shuffle all images down
            setCustomerPhotoDataBase64String(customerPhotoDataBase64String2);
            setCustomerPhotoDataBase64String2(customerPhotoDataBase64String3);
            setCustomerPhotoDataBase64String3(customerPhotoDataBase64String4);
            setCustomerPhotoDataBase64String4(customerPhotoDataBase64String5);
            setCustomerPhotoDataBase64String5('');
        }
        else if (imageNumber == 2) {
            // shuffle all images down
            setCustomerPhotoDataBase64String2(customerPhotoDataBase64String3);
            setCustomerPhotoDataBase64String3(customerPhotoDataBase64String4);
            setCustomerPhotoDataBase64String4(customerPhotoDataBase64String5);
            setCustomerPhotoDataBase64String5('');
        }
        else if (imageNumber == 3) {
            // shuffle all images down
            setCustomerPhotoDataBase64String3(customerPhotoDataBase64String4);
            setCustomerPhotoDataBase64String4(customerPhotoDataBase64String5);
            setCustomerPhotoDataBase64String5('');
        }
        else if (imageNumber == 4) {
            // shuffle all images down
            setCustomerPhotoDataBase64String4(customerPhotoDataBase64String5);
            setCustomerPhotoDataBase64String5('');
        }
        else if (imageNumber == 5) {
            // shuffle all images down
            setCustomerPhotoDataBase64String5('');
        }
    }

    function savePhotos() {
        order.CustomerPhotoDataBase64String = customerPhotoDataBase64String;
        order.CustomerPhotoDataBase64String2 = customerPhotoDataBase64String2;
        order.CustomerPhotoDataBase64String3 = customerPhotoDataBase64String3;
        order.CustomerPhotoDataBase64String4 = customerPhotoDataBase64String4;
        order.CustomerPhotoDataBase64String5 = customerPhotoDataBase64String5;

        updateOrder();
    }

    function showDialogPhotos() {

        let orderCopy = cloneDeep(order);
       
        return (<Dialog
            open={true}
            onClose={closeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Add/Remove Photos
            </DialogTitle>
            <DialogContent>
                <div>
                    {(customerPhotoDataBase64String == '' || customerPhotoDataBase64String2 == '' || customerPhotoDataBase64String3 == '' || customerPhotoDataBase64String4 == '' || customerPhotoDataBase64String5 == '') ?
                        <>
                            <input
                                style={{ display: 'none' }}
                                accept="image/*"
                                id="contained-button-file"
                                multiple
                                type="file"
                                onChange={handleUploadImageClick}
                            />
                            <label htmlFor="contained-button-file" className="MuiButtonBase-root MuiButton-root MuiLoadingButton-root MuiButton-contained MuiButton-containedSipzeeYellow MuiButton-sizeMedium MuiButton-containedSizeMedium css-1fb4g0m-MuiButtonBase-root-MuiButton-root-MuiLoadingButton-root" style={{ width: '175px' }}>
                                Add Photos
                                <AddAPhotoIcon />
                                </label>
                        </>
                        :
                        null
                    }
                </div>
                {customerPhotoDataBase64String == '' ? null :
                    <div >
                        <Fab onClick={() => removeImage(1)}>
                            <DeleteIcon />
                        </Fab>
                        <img src={customerPhotoDataBase64String}/>
                    </div>    
                }

                {customerPhotoDataBase64String2 == '' ? null :
                    <div >
                        <Fab onClick={() => removeImage(2)}>
                            <DeleteIcon />
                        </Fab>
                        <img src={customerPhotoDataBase64String2} />
                    </div>
                }

                {customerPhotoDataBase64String3 == '' ? null :
                    <div >
                        <Fab onClick={() => removeImage(3)}>
                            <DeleteIcon />
                        </Fab>
                        <img src={customerPhotoDataBase64String3} />
                    </div>
                }

                {customerPhotoDataBase64String4 == '' ? null :
                    <div >
                        <Fab onClick={() => removeImage(4)}>
                            <DeleteIcon />
                        </Fab>
                        <img src={customerPhotoDataBase64String4} />
                    </div>
                }

                {customerPhotoDataBase64String5 == '' ? null :
                    <div >
                        <Fab onClick={() => removeImage(5)}>
                            <DeleteIcon />
                        </Fab>
                        <img src={customerPhotoDataBase64String5} />
                    </div>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} autoFocus>
                    Cancel
                </Button>
                <Button onClick={savePhotos} autoFocus>
                    Save
                </Button>
            </DialogActions>
        </Dialog>)
    }

    //#endregion

   function getWebToken() {

        try {
            return JSON.parse(localStorage.getItem('Login')).WebToken; // persists after window close
        }
        catch {

        }


        return null;
    }

    function chatMessagesViewed() {
        let clientType = '';
        if (loggedInUser === undefined || loggedInUser === null) {
            clientType = 'customer';
        }
        else if (loggedInUser.EmailAddress.toLowerCase() === order.Owner.toLowerCase()) {
            clientType = 'recycler'
        }
        else {
            // check if use is an Admin
            if (loggedInUser.UserAccess.includes('ADMIN')) {
                clientType = 'admin'
            }
            else {
                return;
            }
        }
        let postData = {
            clientType: clientType,
            orderGuid: order.OrderGUID
        }

        //TokenService.post(postData, 'ChatMessageViewed')
        //    .then((response) => {
        //        let orderCopy = cloneDeep(order);
        //        if (loggedInUser === undefined) {
        //            let count = 0;
        //            for (let i = 0; i < orderCopy.ChatMessages.length; i++) {
        //                if (orderCopy.ChatMessages[i].ViewedByCustomerUTC == '0001-01-01T00:00:00' && orderCopy.ChatMessages[i].SenderType !== 'customer') {
        //                    orderCopy.ChatMessages[i].ViewedByCustomerUTC = dayjs.utc().format();
        //                }
        //            }

        //            setOrder(orderCopy);

        //        }
        //    })
        //    .catch((response) => {

        //    });
    }



    return (
        <div componentname='AdminOrderView' className='CustomerOrder' style={{paddingBottom:'100px'} }>

        <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#f5f5f5', paddingBottom:'75px' }}>
            <Card sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding: '0px', marginTop: '10px' }}>
                    <CardContent style={{ padding: '5px' }}>
                        <div style={{display:'flex'} }>
                            <Button sx={{ backgroundColor: 'var(--sipzee-green-2)' }} onClick={() => props.onBack()}>Back</Button>
                        </div>
                    {loadingPanel}
                    {customerOrderPanel}
                </CardContent>
            </Card>
                {order.Status === 'Open' && order.Status_Reason === 'Scheduled' ?
                    <ChatBox FloatingButton={true} order={order} messagesViewed={(thisOrder) => chatMessagesViewed(thisOrder)} loggedInUser={loggedInUser} onMessageAdded={(chatMessage) => handleMessageAdded(chatMessage)} recipient={loggedInUser === undefined ? 'customer' : 'admin'} />
                :
                null
            }
        </div>

            {showDialog === 'Order Status' ?
                showDialogOrderStatus()
                :null
            }

            {showDialog === 'Your Info' ?
               showDialogYourInfo()
                : null
            }

            {showDialog === 'Address' ?
                showDialogAddress()
                : null
            }

            {showDialog === 'Financials' ?
                showDialogFinancials()
                : null
            }
           
            {showDialog === 'Special Instructions' ?
                showDialogSpecialInstructions()
                : null
            }
           


            {showDialog === 'Business Hours' ?
                showDialogBusinessHours()
                : null
            }

           
            {showDialog === 'Estimator' ?
                showDialogEstimator()
                : null
            }

            {showDialog === 'Extend Time' ?
                showDialogExtendTime()
                : null
            }

            {showDialog === 'Cancel Order' ?
                showDialogCancelOrder()
                : null
            }

            {showDialog === 'Photos' ?
                showDialogPhotos()
                : null
            }

            {showDialog === 'Recycler Search' ?
                <ReassignPickupModal Order={order} onClose={closeAssignToOtherDialog} />
                : null
            }

            {confirmDialog !== null ?
                    <ConfirmDialog Close={confirmDialog.close} Title={confirmDialog.title} Content={confirmDialog.content} CancelText={confirmDialog.cancelText} AcceptText={confirmDialog.acceptText} Data={confirmDialog.data} />
                    : null
            }

            
        </div>
    )
    

}

